<mat-accordion>
  <mat-expansion-panel [expanded]="true" (opened)="onOpenLegendsPanel('plddt')">
    <mat-expansion-panel-header [ngStyle]="{'background-color': colorscheme == 'plddt' ? '#B9D4F1' : 'transparent'}">
      <mat-panel-title> Model Confidence</mat-panel-title>
    </mat-expansion-panel-header>
    <div class="modelInfo">
      <div class="confidenceWrapper">
        @for (legend of viewerLegend; track legend) {
          <div class="column legendRow">
            <span class="legendColor" [ngStyle]="legend.style">&nbsp;</span
              ><span class="legendlabel">{{ legend.label }}</span>
            </div>
          }
        </div>
        <div class="column legendDesc">
          pLDDT is a per-residue measure of local confidence.
                <a (click)="gaService.eventEmitter(
                'link_visit',
                'home_href_click',
                'click',
                'faq_accuracy',
                '')" [routerLink]="['/faq']" fragment="faq-12" class="licenseLink" target="_blank">Learn more...</a>
        </div>
      </div>
    </mat-expansion-panel>
    @if (entryData().isComplex === true) {
      <mat-expansion-panel (opened)="onOpenLegendsPanel('macromolecules')">
        <mat-expansion-panel-header [ngStyle]="{'background-color': colorscheme == 'macromolecules' ? '#B9D4F1' : 'transparent'}">
          <mat-panel-title> Macromolecules ({{macromoleculesData().length}}) </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="macro-info">
          @for (macro of macromoleculesData(); track macro; let i = $index) {
            <div class="macromolecule-row" (click)="onMacromoleculeClick(i)" [class.selected]="hasMacromoleculeSelection && selectedMacromoleculeIndex === i">
              <span class="macromolecule-bar" [class.is-dimmed]="hasMacromoleculeSelection && selectedMacromoleculeIndex !== i"></span>
              <span class="macromolecule-label" [title]="macro.uniprotDescription" [class.selected]="hasMacromoleculeSelection && selectedMacromoleculeIndex === i">
                 {{ !macro.uniprotDescription ? "Not named" : macro.uniprotDescription.length > 200 ? (macro.uniprotDescription | slice:0:200) + '...' : macro.uniprotDescription }}
              </span>
            </div>
          }
        </div>
      </mat-expansion-panel>
    }
    <mat-expansion-panel (opened)="onOpenLegendsPanel('ted')">
      <mat-expansion-panel-header [ngStyle]="{'background-color': colorscheme == 'ted' ? '#B9D4F1' : 'transparent'}">
        <mat-panel-title> Domains ({{tedDomainData().length}}) </mat-panel-title>
      </mat-expansion-panel-header>

      <div
        [ngClass]="{ 'scrollable-body': domainCount > 5, 'non-scrollable-body': domainCount <= 5 }">
        @if (domainCount > 0) {
          <div class="legend-title">TED</div>
        }
        <div class="modelInfo">
          @if (domainCount > 0) {
            <div class="confidenceWrapper">
              @for (ted of slicedTedDomain(); track ted; let i = $index) {
                <div
                  class="column legendRow"
                  >
                  <span class="legendColor"
                  [style.background]="utilService.fetchColorByIndex(i)">&nbsp;</span>
                  <span class="legendlabel">Domain {{ ted.ted_domain_no }}</span>
                </div>
              }
            </div>
          }
          @if (domainCount > 0) {
            <div class="column legendDesc">
              The Encyclopedia of Domains (TED) identifies and classifies structural domains.
                      <a (click)="gaService.eventEmitter(
                        'link_visit',
                        'home_href_click',
                        'click',
                        'ted',
                        'Clicks on Learn more in Domains accordion')" [routerLink]="['/faq']" fragment="faq-26" class="licenseLink" target="_blank">Learn more... </a>
            </div>
          }
          @if (domainCount == 0) {
            <div class="column legendDesc">
              This protein does not currently have any structural domains identified. Domain annotations will appear here if data becomes available in future updates.
            </div>
          }
        </div>
      </div>

    </mat-expansion-panel>
    <mat-expansion-panel (opened)="onOpenLegendsPanel('missense')">
      <mat-expansion-panel-header [ngStyle]="{'background-color': colorscheme == 'missense' ? '#B9D4F1' : 'transparent'}">
        <mat-panel-title> Annotations </mat-panel-title>
      </mat-expansion-panel-header>
      @if (entryData().amAnnotationsUrl) {
        <div>
          <div class="legend-title">AlphaMissense Pathogenicity</div>
          <div class="modelInfo">
            <div class="confidenceWrapper">
              @for (alpha of alphamissenseLegends; track alpha) {
                <div
                  class="column legendRow"
                  >
                  <span class="legendColor" [ngStyle]="alpha.style">&nbsp;</span
                    ><span class="legendlabel">{{ alpha.label }}</span>
                  </div>
                }
              </div>
              <div class="column legendDesc">
              Colour shows the average predicted pathogenicity for all possible substitutions at that position. <a (click)="gaService.eventEmitter(
                'link_visit',
                'home_href_click',
                'click',
                'ted',
                'Clicks on Learn more in Annotations accordion')" [routerLink]="['/faq']" fragment="faq-22" class="licenseLink" target="_blank">Learn more...</a>
            </div>
          </div>
        </div>
      }

      @if (entryData().amAnnotationsUrl === undefined || entryData().amAnnotationsUrl === '' || entryData().amAnnotationsUrl === null) {
        <div class="column legendDesc">
          This protein does not currently have any annotations identified. Annotations will appear here if data becomes available in future updates.
        </div>
      }

    </mat-expansion-panel>
  </mat-accordion>
